module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAQtJREFUWEftleENgkAMRh8bOIJOoG6gk+hoOomOoBPoCI6gTbiEkBOP+0pCTO8fwX48X1tomPlpZs5HAKodCoNhUDWg1scMhkHVgFr/NzO4A9bAGXiJVhbAAbgD119ZJQaXn8BHG3QD9gKkwV2ATZu3Ap5DkCWAZs9C06mF7MNZ3hawvK+nBNCKT21baiFzcDYuR48Wp4xayGo4e3CpwVpICa4GcEy7ZbhawBJIFzgFcAjS7nVfJXZdtBC5hRk7g/2M3OLYb9J7ToJTDX5bnO6fqDaXQlSDQ5AynJfBHKQLnDeg5aUvg82my/FqsQvMFFs8GZj3kkwGGi1W1YbBMKgaUOtjBsOgakCtfwOGZjUpFdvY0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image2/down.png
// module id = SkA2
// module chunks = 21